<div>
    <app-header [title]="'myrewards.my_points' | translate" (onBackLinkClick)="goToMyPoints()"  [backLinkText]="'myrewards.go_back' | translate"/>

    <!-- Bounded container -->
    <div class="max-w-screen-xl mx-auto px-4 py-8 grid grid-cols-1 lg:grid-cols-12 gap-6 bg-gray-50 min-h-screen">
        <!-- COL: Main (left, col-span-8 on desktop) -->
        <div class="col-span-12 lg:col-span-9 flex flex-col gap-6">
            <!-- Section: My Points -->
            <!-- GRID: 3 box de resumen -->

            <!-- Tarjeta blanca -->
            <div class="bg-white flex flex-col lg:flex-row items-start">
                <!-- Sección izquierda: resumen -->
                <div class="flex flex-col w-full lg:w-2/3 gap-6 p-6">
                    <div>
                        <span class="typography-title-m textPrimary-color">{{ 'myrewards.my_points' | translate }}</span>
                        <br />
                        <span class="typography-body-s-regular textSecondary-color">  {{ 'myrewards.global_position' | translate : { date: (today | date:'shortDate') } }}</span>
                    </div>

                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                        <!-- Box 1 -->
                        <div class="flex flex-row items-center">
                            <app-cosentino-svg class="icon" [svgName]="'expiring-actios'" [size]="60" style="color: var(--primaryActive)"></app-cosentino-svg>
                            <div class="bg-background-light-01 px-4 py-3 flex items-start gap-4 w-full h-full">
                                <div class="flex flex-col justify-between gap-2 h-full">
                                    <span class="typography-body-s-regular textPrimary-color">{{ 'myrewards.expiring_soon' | translate }}</span>
                                    <span class="typography-body-m-medium primaryDefault-color">{{soonToExpireActios}}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Box 2 -->
                        <div class="flex flex-row items-center">
                            <app-cosentino-svg class="icon" [svgName]="'no-expiring-actios'" [size]="60" style="color: var(--primaryActive)"></app-cosentino-svg>
                            <div class="bg-background-light-01 p-4 flex items-start gap-4 w-full h-full">
                                <div class="flex flex-col justify-between gap-2 h-full">
                                    <span class="typography-body-s-regular textPrimary-color">{{ 'myrewards.not_expiring_soon' | translate }}</span>
                                    <span class="typography-body-m-medium primaryDefault-color">{{noNearExpirationActios}}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Box 3 -->
                        <div class="flex flex-row items-center">
                            <app-cosentino-svg class="icon" [svgName]="'pending-actios'" [size]="60" style="color: var(--primaryActive)"></app-cosentino-svg>
                            <div class="bg-background-light-01 p-4 flex items-start gap-4 w-full h-full">
                                <div class="flex flex-col justify-between gap-2 h-full">
                                    <span class="typography-body-s-regular textPrimary-color">{{ 'myrewards.pending_validation' | translate }}</span>
                                    <span class="typography-body-m-medium primaryDefault-color">{{pendingValidationActios}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Divider vertical en desktop -->
                <div class="hidden lg:block border-l border-gray-200 mx-4 h-full"></div>
                <div class="lg:hidden divider w-full my-4"></div>

                <!-- Sección derecha: puntos totales -->
                <div class="w-full lg:w-1/3 flex flex-col items-center gap-4 p-4">
                    <span class="typography-body-l-medium textPrimary-color">
                        {{ 'myrewards.total_available_points' | translate }}:
                    </span>
                    <span class="typography-title-l primaryDefault-color">{{availableActios}} {{ 'myrewards.points' | translate }}</span>
                    <app-button *ngIf="canExchangePoints" [primary]="true" size="l" class="w-full" (onClick)="redeemPoints()">
                        {{ 'myrewards.redeem_my_points' | translate }}
                    </app-button>
                </div>
            </div>

            <!-- Transaction Summary -->
            <div class="bg-white px-4 py-3">
                <div class="flex justify-between items-center mb-4">
                    <span class="typography-title-s">{{ 'myrewards.transaction_summary' | translate }}</span>
                    <app-link [contentClass]="'text-primary no-underline'" class="flex flex-row items-center mt-1 typography-body-s-regular text-text-primary" (onClick)="goToTransactionSummary()">
                      <div class="flex items-center">
                        <span>{{ 'myrewards.view_all' | translate }}</span>
                        <svg c-cosentinoSvg_chevronRight="" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                c-cosentinoSvg_chevronRight=""
                                class="primaryDefault"
                                d="M9.4002 17.3L8.7002 16.6L13.3002 12L8.7002 7.39995L9.4002 6.69995L14.7002 12L9.4002 17.3Z"
                                fill="#232323"
                            ></path>
                        </svg>
                        </div>
                    </app-link>
                </div>
                <div class="divider w-full mb-2"></div>

                <div class="overflow-auto">
                    <app-table [data]="transactionData | slice:0:3"  [columns]="transactionColumns" [selectable]="false" [noDataMessage]="'myrewards.no_results_found' | translate"></app-table>
                </div>
            </div>

            <!-- Redeemed Rewards -->
            <div class="bg-white p-4">
                <div class="flex justify-between items-center">
                    <span class="typography-title-s">{{ 'myrewards.redeemed_rewards' | translate }} <span class="text-primary">({{redeemedRewards.length}})</span></span>
                    <app-link [contentClass]="'text-primary no-underline'" class="block mt-1 typography-body-s-regular text-text-primary" (onClick)="goToRedeemedRewards()">
                                            <div class="flex items-center">

                        <span>{{ 'myrewards.view_all' | translate }}</span>
                        <svg c-cosentinoSvg_chevronRight="" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                c-cosentinoSvg_chevronRight=""
                                class="primaryDefault"
                                d="M9.4002 17.3L8.7002 16.6L13.3002 12L8.7002 7.39995L9.4002 6.69995L14.7002 12L9.4002 17.3Z"
                                fill="#232323"
                            ></path>
                        </svg>
                        </div>
                    </app-link>
                </div>
                <div class="divider w-full mb-2"></div>

                <p class="typography-body-l-medium">
                    {{ 'myrewards.total_redeemed_rewards' | translate }}:
                    <span class="typography-body-l-medium text-primary">{{ getTotalRedeemedPoints() }}</span>
                </p>
                <div class="grid grid-cols-12 gap-4">
                  <div class="flex flex-col gap-4 items-start col-span-12 md:col-span-4 lg:col-span-3" *ngFor="let item of redeemedRewards | slice:0:4">
                      <img src="https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/actios/images/giftcard-desktop.png" alt="Reward" class="w-full object-cover" />
                      <div>
                          <span class="typography-body-m-regular">{{item.name}}</span><br/>
                          <span class="typography-body-s-regular text-primary">{{item.pointCost}} {{"myrewards.points" | translate}}</span> 
                      </div>
                  </div>
                </div>
                
            </div>

            <!-- Registrations by Employee -->
            <div class="bg-white p-4">
                <div class="flex justify-between items-center">
                    <span class="typography-title-s">{{ 'myrewards.registrations_by_employee' | translate }}</span>
                    <app-link [contentClass]="'text-primary no-underline'" class=" mt-1 typography-body-s-regular text-text-primary" (onClick)="goToEmployeeSummary()">
                      <div class="flex items-center">
                        <span class="">{{ 'myrewards.view_all' | translate }}</span>
                        <svg c-cosentinoSvg_chevronRight="" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                c-cosentinoSvg_chevronRight=""
                                class="primaryDefault"
                                d="M9.4002 17.3L8.7002 16.6L13.3002 12L8.7002 7.39995L9.4002 6.69995L14.7002 12L9.4002 17.3Z"
                                fill="#232323"
                            ></path>
                        </svg>
                        </div>
                    </app-link>
                </div>
                <div class="divider w-full mb-2"></div>
                <div class="overflow-auto">
                    <app-table [data]="employeeSummaries | slice:0:3" [columns]="employeeSummaryColumns" [selectable]="false" [noDataMessage]="'myrewards.no_results_found' | translate"></app-table>
                </div>
            </div>
        </div>

        <!-- COL: Right Sidebar -->
        <div class="col-span-12 lg:col-span-3">
            <div
                class="w-full"
                style="
                    padding: 24px;
                    background: #bde2ec;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    gap: 16px;
                    display: inline-flex;
                    height: fit-content;
                "
            >
                <div style="align-self: stretch; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 8px; display: flex">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.5rem" height="1.5rem" viewBox="0 0 24 24" fill="none" style="vertical-align: middle">
                        <path
                            class="primaryDefault"
                            d="M11.5 16.5H12.5V11H11.5V16.5ZM12 9.575C12.1667 9.575 12.3127 9.51667 12.438 9.4C12.5627 9.28333 12.625 9.13333 12.625 8.95C12.625 8.78333 12.5627 8.64167 12.438 8.525C12.3127 8.40833 12.1667 8.35 12 8.35C11.8333 8.35 11.6873 8.40833 11.562 8.525C11.4373 8.64167 11.375 8.78333 11.375 8.95C11.375 9.13333 11.4373 9.28333 11.562 9.4C11.6873 9.51667 11.8333 9.575 12 9.575ZM12 21C10.75 21 9.57933 20.7627 8.488 20.288C7.396 19.8127 6.446 19.1707 5.638 18.362C4.82933 17.554 4.18733 16.604 3.712 15.512C3.23733 14.4207 3 13.25 3 12C3 10.75 3.23733 9.579 3.712 8.487C4.18733 7.39567 4.82933 6.44567 5.638 5.637C6.446 4.829 7.396 4.18733 8.488 3.712C9.57933 3.23733 10.75 3 12 3C13.25 3 14.421 3.23733 15.513 3.712C16.6043 4.18733 17.5543 4.829 18.363 5.637C19.171 6.44567 19.8127 7.39567 20.288 8.487C20.7627 9.579 21 10.75 21 12C21 13.25 20.7627 14.4207 20.288 15.512C19.8127 16.604 19.171 17.554 18.363 18.362C17.5543 19.1707 16.6043 19.8127 15.513 20.288C14.421 20.7627 13.25 21 12 21ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
                            fill="#232323"
                        />
                    </svg>

                    <div style="align-self: stretch; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 8px; display: flex">
                        <div
                            class="typography-title-m"
                            style="align-self: stretch; color: #323232; font-size: 20px; font-family: Diagramm; font-weight: 500; line-height: 24px; word-wrap: break-word"
                        >
                            {{ 'myrewards.title_what_are_points' | translate }}
                        </div>
                        <p class="typography-body-l-regular">{{ 'myrewards.info_paragraph' | translate }}</p>

                        <app-button [secondary]="true" size="l" class="w-full" (onClick)="knowYourBenefits()">
                            {{ 'myrewards.know_rewards_plan' | translate }}
                        </app-button>
                    </div>
                </div>
            </div>
            <div class="lg:col-span-4 flex flex-col gap-6">
            <app-dynamic-banner></app-dynamic-banner>
            </div>
        </div>
    </div>
</div>
